import React, { RefObject, useCallback } from 'react'

import {
  DropdownDynamic as CoreDropdownDynamic,
  IDropdownDynamicProps,
} from 'core-components/library/dropdown'

import { ITranslateInputProps } from '../inputs'

export interface ITranslateDropdownDynamic extends IDropdownDynamicProps {
  translation?: string
  inputRef?: RefObject<HTMLInputElement>
}

export const DropdownDynamic = (props: ITranslateDropdownDynamic) => {
  const prepareConfig = useCallback(
    (config: ITranslateInputProps) => {
      config.translation = props.translation
      config.inputRef = props.inputRef
    },
    [props.translation, props.inputRef]
  )
  return <CoreDropdownDynamic {...props} prepareInputConfig={prepareConfig} />
}
